import storeSchema from './storeSchema';

const responseStoreSchema = [storeSchema];

export default responseStoreSchema;
